export class DateIdentificacionModel {
    Desde: Date = new Date();
    Hasta: Date = new Date();
}